import {Injectable} from "@angular/core";
import {Bank} from "../model/bank.model";
import {BankService} from "../service/bank.service";

@Injectable()
export class BankInteractor {
    constructor(private bankService: BankService) {
    }

    public async getBankDetailsByIfscCode(ifscCode: string): Promise<Bank> {
        return this.bankService.findByIfsc(ifscCode);
    }

    public async getBankNames(): Promise<string[]> {
        return await this.bankService.getBankList();
    }

    public async getCitiesbyBankName(bankName: string): Promise<string[]> {
        return await this.bankService.getCityList(bankName);
    }

    public async getBankBranches(bankName: string, city: string): Promise<string[]> {
        return await this.bankService.getBranchNamesByBankNameAndCity(bankName, city);
    }

    public async getIfsc(branchName: string, bankName: string): Promise<string> {
        return await this.bankService.getIfscByBranchAndBankName(branchName, bankName);
    }
}
